import React, { useState, useEffect } from "react";

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  position: "left" | "right";
  title: string;
  width?: number;
  children: React.ReactNode;
}

const Drawer: React.FC<DrawerProps> = ({
  isOpen,
  onClose,
  position,
  title,
  width = 320,
  children,
}) => {
  const [animationClass, setAnimationClass] = useState("");

  useEffect(() => {
    if (isOpen) {
      setAnimationClass("translate-x-0");
    } else {
      setAnimationClass(
        position === "left" ? "-translate-x-full" : "translate-x-full"
      );
    }
  }, [isOpen, position]);

  return (
    <div
      className={`fixed inset-0 z-50 overflow-hidden ${
        isOpen ? "block" : "hidden"
      }`}
    >
      {isOpen && (
        <div
          className="fixed inset-0 bg-black opacity-50"
          onClick={onClose}
        ></div>
      )}
      <div
        style={{ width: `${width}px` }}
        className={`fixed ${
          position === "left" ? "left-0" : "right-0"
        } top-0 h-full bg-white shadow transform ${animationClass} transition-transform duration-300 ease-in-out`}
      >
        <div
          className={`p-4 border-b flex gap-2 items-center ${
            position === "left" && "flex-row-reverse"
          }`}
        >
          <button
            className="text-xl rounded-full px-2 py-0 border shadow hover:bg-red-500 hover:text-white"
            onClick={onClose}
          >
            ×
          </button>
          <h2 className="text-md font-semibold">{title}</h2>
        </div>
        <div className="p-4">{children}</div>
      </div>
    </div>
  );
};

export default Drawer;
